<div atlas-banner>
  <img atlas-banner-image 
    [src]="data.imageURL">
  <div atlas-banner-content>
    <p class="m-0 mat-body">
      {{data.content}}
    </p>
  </div>
  <div atlas-banner-actions>
    <button atlas-button
      color="accent"
      class="text-uppercase me-2"
      (click)="getDismissAction()">
      {{data.secondaryAction}}
    </button>
    <button atlas-button
      color="accent"
      class="text-uppercase"
      (click)="performAction()">
      {{data.primaryAction}}
    </button>
  </div>
</div>